import { useEffect, useRef } from 'react';

interface UseIdleTimerProps {
  onIdle: () => void;
  idleTime: number; // em milissegundos
}

export const useIdleTimer = ({ onIdle, idleTime }: UseIdleTimerProps) => {
  const timeoutId = useRef<number | null>(null);

  const resetTimer = () => {
    if (timeoutId.current) {
      window.clearTimeout(timeoutId.current);
    }
    timeoutId.current = window.setTimeout(onIdle, idleTime);
  };

  const handleEvent = () => {
    resetTimer();
  };

  useEffect(() => {
    // Se o tempo de inatividade for 0, não faz nada (sessão nunca expira)
    if (idleTime <= 0) {
      return;
    }

    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    // Inicia o timer
    resetTimer();

    // Adiciona os event listeners
    events.forEach(event => {
      window.addEventListener(event, handleEvent);
    });

    // Função de limpeza para remover os listeners e o timer
    return () => {
      if (timeoutId.current) {
        window.clearTimeout(timeoutId.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, handleEvent);
      });
    };
  }, [idleTime, onIdle]);

  return null;
};